export default __webpack_public_path__ + "static/media/dhu.6b7f87ee.png";